module.exports = __webpack_public_path__ + "img/Christian.5fc687c3.png";